<template>
  <div style="height: 100%">
    <div class="background" :style="sectionBackgroundStyle">
      <div class="overlay"></div>
    </div>
    <div class="pa-6">
      <v-card
        class="
          d-flex
          flex-column
          justify-center
          align-center
          pa-6
          py-10
          mx-2
          my-4
          d-flex
        "
        elevation="0"
      >
        <h1 class="display-1 font-weight-light text-center">
          Update Emergency Contacts
        </h1>
        <v-container style="width: 100%">
          <v-row
            v-for="(contact, index) in emergencyContacts"
            :key="index"
            class="pb-2"
          >
            <v-col cols="12" sm="12" md="5" class="py-0">
              <v-text-field
                v-model="contact.name"
                name="Name"
                label="Name"
                background-color="grey lighten-3"
                solo
                dense
                flat
                required
                :rules="nameRules"
              >
                <template v-slot:prepend>
                  <a @click="removeContact(index)">
                    <v-icon>mdi-close</v-icon>
                  </a>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="4" class="py-0">
              <v-text-field
                v-model="contact.email"
                name="email"
                label="Email Address"
                required
                background-color="grey lighten-3"
                solo
                dense
                flat
                :rules="emailRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3" class="py-0">
              <v-text-field
                v-model="contact.contactNumber"
                name="Contact Number"
                label="Contact Number"
                required
                background-color="grey lighten-3"
                solo
                dense
                flat
                :rules="contactNumberRules"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-btn x-small text color="red" @click="addAnother">
            <v-icon x-small>mdi-plus</v-icon> Add Another Emergency Contact
          </v-btn>
        </v-container>
        <div>
          <v-btn
            class="mx-4"
            rounded
            depressed
            color="primary"
            :disabled="submitDisabled"
            @click="submit"
            >Submit</v-btn
          >
        </div>
        <div class="link mt-4">
          <a class="text-tiny" @click="logout">Log Out</a>
        </div>
      </v-card>
    </div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ snackMessage }}
      <v-btn color="primary" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      sectionBackgroundStyle: `background-image: url(${process.env.BASE_URL}images/cover_img_1.jpg); background-size:cover; background-position: center center;background-attachment:fixed;`,
      loading: true,
      snackMessage: '',
      timeout: 5000,
      snackbar: false,
      emergencyContacts: [{ name: '', email: '', contactNumber: '' }],
      // submitDisabled: false,
      emailRules: [
        (v) => validateEmail(v) || 'Please Enter a Valid E-mail Address'
      ],
      nameRules: [(v) => v != '' || 'Name Cannot be Empty'],
      contactNumberRules: [
        (v) => {
          const pattern = /^(09|\+639)\d{9}$/
          return pattern.test(v) || 'Please use the format +63xxxxxxxxxx'
        },
        (v) => v != '' || 'Contact Number Cannot be Empty'
      ]
    }
  },
  computed: {
    submitDisabled() {
      const invalidContacts = this.emergencyContacts.filter(
        (contact) =>
          contact.name == '' ||
          contact.email == '' ||
          contact.contactNumber == ''
      )

      return invalidContacts.length > 0
    }
  },
  async created() {
    const emergencyContacts =
      this.$store.getters['auth/getUser'].emergencyContacts
    if (emergencyContacts.length) {
      this.emergencyContacts = emergencyContacts
    }
    this.loading = false
  },
  methods: {
    addAnother() {
      this.emergencyContacts.push({ name: '', email: '', contactNumber: '' })
    },
    removeContact(index) {
      this.emergencyContacts.splice(index, 1)
    },
    async submit() {
      this.loading = true
      // console.log(this.emergencyContacts)
      await this.$store.dispatch('users/updateUserEmergencyContactsAction', {
        emergencyContacts: this.emergencyContacts
      })
      this.loading = false
      this.$root
        .$confirm({
          title: 'Update Emergency Contact',
          message: `Your emergency contacts have been updated.`,
          reconfirmOnly: true,
          confirmText: 'OK'
        })
        .then(() => {
          this.$router.replace('/comingsoon')
        })
    },
    async logout() {
      await this.$store.dispatch('auth/doLogout')
      // this.$router.go()
      window.location.reload()
    }
  }
}

function validateEmail(email) {
  //eslint-disable-next-line
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase())
}
</script>

<style scoped>
.background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 60%;
}
.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0.95;
  height: 100%;
  background: #662d91;
  background: -moz-linear-gradient(-45deg, #662d91 0%, #798eea 100%);
  background: -webkit-gradient(
    left top,
    right bottom,
    color-stop(0%, #662d91),
    color-stop(100%, #798eea)
  );
  background: -webkit-linear-gradient(-45deg, #662d91 0%, #798eea 100%);
  background: -o-linear-gradient(-45deg, #662d91 0%, #798eea 100%);
  background: -ms-linear-gradient(-45deg, #662d91 0%, #798eea 100%);
  background: -webkit-linear-gradient(315deg, #662d91 0%, #798eea 100%);
  background: -o-linear-gradient(315deg, #662d91 0%, #798eea 100%);
  background: linear-gradient(135deg, #662d91 0%, #798eea 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#662d91', endColorstr='#798eea', GradientType=1 );
}
/*.v-card {
    background: radial-gradient(circle, #555555, #535353, #505050, #4e4e4e, #4c4c4c);
  }*/
.display-1 {
  letter-spacing: 0.5px;
  /*color: white;*/
}
.subtitle-2 {
  letter-spacing: 3px;
  /*color: white;*/
}
.v-card {
  border-radius: 12px !important;
}
</style>
